import { Wifi } from 'lucide-react';

import { RestaurantPrinterDTO } from '../../../../types/restaurant/RestaurantPrinterTypes';

interface PrinterStatsProps {
  printers: RestaurantPrinterDTO[];
}

const PrinterStats = ({ printers }: PrinterStatsProps) => {
  const activeCount = printers.filter((printer) => printer.active).length;
  const networkCount = printers.filter(
    (printer) => printer.active && printer.connectionType === 'NETWORK'
  ).length;

  return (
    <div className="grid grid-cols-1 gap-3 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-meta-4/20 sm:grid-cols-3">
      <div className="rounded-lg border border-stroke bg-white p-4 dark:border-strokedark dark:bg-boxdark">
        <p className="text-xs font-medium uppercase tracking-wide text-bodydark2">
          Registradas
        </p>

        <p className="mt-1 text-2xl font-semibold text-black dark:text-white">
          {printers.length}
        </p>
      </div>

      <div className="rounded-lg border border-stroke bg-white p-4 dark:border-strokedark dark:bg-boxdark">
        <p className="text-xs font-medium uppercase tracking-wide text-bodydark2">
          Activas
        </p>

        <p className="mt-1 text-2xl font-semibold text-success">
          {activeCount}
        </p>
      </div>

      <div className="rounded-lg border border-stroke bg-white p-4 dark:border-strokedark dark:bg-boxdark">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium uppercase tracking-wide text-bodydark2">
              Conectadas por red
            </p>

            <p className="mt-1 text-2xl font-semibold text-black dark:text-white">
              {networkCount}
            </p>
          </div>

          <Wifi className="h-6 w-6 text-primary" />
        </div>
      </div>
    </div>
  );
};

export default PrinterStats;
